import { LoadingSpinner } from "components/LoadingSpinner";
import { centsToDollars, parsePrice } from "helpers/price";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import styled from "styled-components";

const StyledContainer = styled.div`
  border-radius: 8px;
  border: 1px solid var(--gray-new-200);
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export function AllowableVsPtResponsibility({
  first,
  setFirst,
  dataFromAPI,
  isLoading,
  isFetching,
}: {
  first: number;
  setFirst: any;
  dataFromAPI: any;
  isLoading: boolean;
  isFetching: boolean;
}) {
  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div className="flex flex-column gap-3">
      <StyledContainer className="bg-white">
        <div className="p-4">
          <p className="text-md font-bold mb-2">
            Payer Performance in Clear Health
          </p>
          <DataTable
            rowHover
            stripedRows
            dataKey="id"
            editMode="cell"
            className="p-fluid datatable__AllowableVsPtResponsibility"
            value={dataFromAPI?.data || []}
            loading={isFetching}
            responsiveLayout="scroll"
            emptyMessage="No provider payouts to show."
          >
            <Column
              field="payerName"
              header="Payer"
              style={{ minWidth: "150px" }}
            />
            <Column
              field="volume"
              header="Volume"
              style={{ minWidth: "90px" }}
            />
            <Column
              field="totalAllowable"
              header="Total Allowable"
              style={{ minWidth: "150px" }}
              body={(rowData) =>
                parsePrice(centsToDollars(rowData.totalAllowable))
              }
            />
            <Column
              field="totalPtPortion"
              header="Total Pt Portion"
              style={{ minWidth: "140px" }}
              body={(rowData) =>
                parsePrice(centsToDollars(rowData.totalPtPortion))
              }
            />
            <Column
              field="avgTotalAllowable"
              header="Avg Total Allowable"
              style={{ minWidth: "80px" }}
              body={(rowData) =>
                parsePrice(centsToDollars(rowData.avgTotalAllowable))
              }
            />
            <Column
              field="avgPtPortion"
              header="Avg Pt Portion"
              style={{ minWidth: "100px" }}
              body={(rowData) =>
                parsePrice(centsToDollars(rowData.avgPtPortion))
              }
            />
            <Column
              field="avgPtPortionPercent"
              header="Avg Pt Portion Percent"
              style={{ minWidth: "120px" }}
              body={(rowData) =>
                `${Number(rowData.avgPtPortionPercent).toFixed(2)}%`
              }
            />
            <Column
              field="avgPtConversionRate"
              header="Avg Pt Conversion Rate"
              style={{ minWidth: "130px" }}
              body={(rowData) =>
                `${Number(rowData.avgPtConversionRate).toFixed(2)}%`
              }
            />
            <Column
              field="payerScore"
              header="Payer Score"
              style={{ minWidth: "90px" }}
              body={(rowData) =>
                rowData.payerScore == null ? "Low Volume" : rowData.payerScore
              }
            />
          </DataTable>
        </div>
      </StyledContainer>
    </div>
  );
}
